module.exports = __webpack_public_path__ + "static/village_card_img7@2x-dffaf612a7884d732ba3f872643536a9.png";